import { useState, useEffect, useCallback } from 'react';
import { createPortal } from 'react-dom';
import { EditButton, DeleteButton } from '../../components/ActionButtons';
import ModalShell from '../../components/ModalShell';
import { apiRequest } from '../../services/api';
import UsageInfo from '../../components/UsageInfo';
import LoadingSpinner from '../../components/LoadingSpinner';
import EmptyState from '../../components/EmptyState';
import PageHeader from '../../components/PageHeader';

const IKONLAR = {
  'Sadece Oda': '🛏️', 'Oda + Kahvaltı': '☕', 'Yarım Pansiyon': '🍽️',
  'Tam Pansiyon': '🍱', 'Her Şey Dahil': '⭐', 'Ultra Her Şey Dahil': '👑',
  'GÜNLÜK': '📅', 'Giriş belli çıkış değiş': '🔄', 'Saatlik Konaklama': '⏱️',
  'Uzun Dönem Kiralama': '🏠', 'Haftalık Paket': '📆', 'Aylık Konaklama': '🗓️',
  'Balayı Paketi': '💍', 'SPA Dahil': '💆', 'Akşam Yemeği Dahil': '🍷',
};
const getIkon = ad => IKONLAR[ad] || '🏨';
const toTitleCase = (str) => str ? str.toLocaleLowerCase('tr-TR').split(' ').map(word => word.charAt(0).toLocaleUpperCase('tr-TR') + word.slice(1)).join(' ') : '';

function FormHata({ mesaj }) {
  if (!mesaj) return null;
  return <p className="text-[10px] font-black text-rose-500 uppercase tracking-widest mt-2 flex items-center gap-1 animate-shake">⚠️ {mesaj}</p>;
}

function KonaklamaTuruForm({ kayit, onKaydet, onGeri, kaydediliyor, hata }) {
  const yeni = !kayit;
  const [ad, setAd] = useState(kayit?.ad ?? '');
  const [ekFiyat, setEkFiyat] = useState(kayit?.ekFiyat ?? 0);
  const [hatalar, setHatalar] = useState({});

  const INP = (hata) =>
    `w-full border-2 rounded-2xl px-5 py-3.5 text-sm font-bold text-gray-800 transition-[border-color,box-shadow,background-color] duration-200 bg-white focus:outline-none ${hata ? 'border-rose-400 bg-rose-50 focus:border-rose-500 shadow-rose-50 shadow-inner' : 'border-gray-100 focus:border-indigo-400 focus:ring-4 focus:ring-indigo-50 shadow-sm'
    }`;

  async function handleKaydet() {
    if (!ad.trim()) { setHatalar({ ad: 'Paket adı zorunludur.' }); return; }
    onKaydet({ ...(kayit ? { konaklamaTuruId: kayit.konaklamaTuruId } : {}), ad: ad.trim(), ekFiyat: parseFloat(ekFiyat) || 0 });
  }

  return (
    <ModalShell
      icon={yeni ? '➕' : '✏️'}
      iconColor="from-indigo-600 to-purple-700"
      title={yeni ? 'Yeni Konaklama Paketi' : `"${kayit.ad}" Düzenle`}
      subtitle="Pansiyon tipleri ve paket içerikleri"
      onClose={onGeri}
      size="md"
      footer={
        <>
          <button onClick={onGeri} className="px-8 py-3.5 rounded-2xl border-2 border-gray-100 text-xs font-black text-gray-400 hover:bg-gray-100 transition-all uppercase tracking-widest active:scale-95">İPTAL</button>
          <button onClick={handleKaydet} disabled={kaydediliyor}
            className="px-10 py-3.5 bg-gradient-to-r from-indigo-500 to-purple-600 hover:from-indigo-600 hover:to-purple-700 disabled:opacity-60 text-white rounded-2xl text-xs font-black shadow-xl shadow-indigo-200 transition-all hover:-translate-y-1 active:translate-y-0 tracking-widest uppercase">
            {kaydediliyor ? '⌛ KAYDEDİLİYOR...' : '💾 PAKETİ KAYDET'}
          </button>
        </>
      }
    >
      <div className="space-y-6">
          {(hata || hatalar.genel) && <div className="bg-rose-50 border-2 border-rose-100 rounded-2xl px-5 py-4 text-xs text-rose-600 font-black uppercase tracking-widest leading-none animate-shake">⚠️ {hata || hatalar.genel}</div>}

          <div>
            <label className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] block mb-3 ml-1">PAKET ADI *</label>
            <input value={ad} onChange={e => { setAd(toTitleCase(e.target.value)); setHatalar({}); }}
              className={INP(hatalar.ad)} placeholder="Örn: Oda + Kahvaltı, Her Şey Dahil" autoFocus onKeyDown={e => e.key === 'Enter' && handleKaydet()} />
            <FormHata mesaj={hatalar.ad} />
          </div>

          <div>
            <label className="text-[10px] font-black text-gray-400 uppercase tracking-[0.2em] block mb-3 ml-1">KİŞİ BAŞI GÜNLÜK EK FİYAT</label>
            <div className="relative">
              <input type="number" min="0" step="10" value={ekFiyat} onChange={e => setEkFiyat(e.target.value)}
                className={INP(false) + ' pr-12 text-center h-[54px] shadow-inner font-black text-lg'} placeholder="0" />
              <span className="absolute right-5 top-1/2 -translate-y-1/2 font-black text-gray-300 text-sm">₺</span>
            </div>
            <p className="text-[9px] font-bold text-indigo-400 mt-4 uppercase tracking-[0.15em] border-l-4 border-indigo-100 pl-4 bg-indigo-50/30 py-2 rounded-r-xl leading-relaxed">BU FİYAT KİŞİ SAYISI VE GECELEME İLE ÇARPILARAK TOPLAM FİYATA EKLENİR.</p>
          </div>

          {ad.trim() && (
            <div className="bg-indigo-50/30 rounded-[2rem] p-6 border-2 border-indigo-100 border-dashed animate-fadeIn flex items-center gap-6 leading-none shadow-sm shadow-indigo-50">
              <div className="w-16 h-16 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-2xl flex items-center justify-center text-3xl shadow-xl shadow-indigo-100/50 transform-gpu group-hover:scale-110 transition-transform">
                {getIkon(ad.trim())}
              </div>
              <div className="text-left">
                <span className="block font-black text-gray-800 text-lg uppercase tracking-tight mb-2.5">{ad.trim()}</span>
                <span className={`text-[10px] font-black uppercase tracking-widest px-3 py-1.5 rounded-lg border leading-none inline-block ${ekFiyat > 0 ? 'bg-indigo-100 text-indigo-700 border-indigo-200' : 'bg-gray-100 text-gray-400 border-gray-200'}`}>
                  {ekFiyat > 0 ? `+${parseFloat(ekFiyat).toLocaleString('tr-TR')} ₺ / KİŞİ GÜNLÜK` : 'STANDART PAKET (EK ÜCRET YOK)'}
                </span>
              </div>
            </div>
          )}
      </div>
    </ModalShell>
  );
}

export default function KonaklamaTurleri() {
  const [liste, setListe] = useState([]);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [hata, setHata] = useState(null);
  const [view, setView] = useState('liste');
  const [secili, setSecili] = useState(null);
  const [silOnay, setSilOnay] = useState(null);
  const [arama, setArama] = useState('');
  const [kaydediliyor, setKaydediliyor] = useState(false);

  const veriYukle = useCallback(async () => {
    setYukleniyor(true); setHata(null);
    try { setListe((await apiRequest('konaklamaturleri')) || []); }
    catch { setHata('Veriler yüklenemedi.'); }
    setYukleniyor(false);
  }, []);

  useEffect(() => { veriYukle(); }, [veriYukle]);

  async function kaydet(form) {
    setKaydediliyor(true); setHata(null);
    try {
      if (form.konaklamaTuruId) await apiRequest('konaklamaturleri', 'PUT', form);
      else await apiRequest('konaklamaturleri', 'POST', form);
      await veriYukle(); setView('liste'); setSecili(null);
    } catch { setHata('Kayıt sırasında hata oluştu.'); }
    setKaydediliyor(false);
  }

  async function handleSil(id) {
    try { await apiRequest(`konaklamaturleri/${id}`, 'DELETE'); setListe(p => p.filter(x => x.konaklamaTuruId !== id)); setSilOnay(null); }
    catch (e) { alert(e?.message || 'Hata oluştu.'); }
  }

  const filtrelenmis = liste.filter(x => x.ad?.toLocaleLowerCase('tr-TR').includes(arama.toLocaleLowerCase('tr-TR')));
  const ic = (kelime) => liste.filter(x => x.ad?.toLocaleLowerCase('tr-TR').includes(kelime)).length;
  const isOpen = view === 'ekle' || view === 'duzenle';

  return (
    <div className="p-3 md:p-6 space-y-7 min-h-screen bg-gray-50/50 animate-fadeIn" style={{ transform: 'translateZ(0)' }}>
      <PageHeader
        icon="🛌"
        iconColor="from-indigo-500 to-purple-700"
        iconShadow="shadow-indigo-200"
        title="Konaklama Paketleri"
        subtitle="Pansiyon tipleri, paket içerikleri ve maliyetler"
      >
        <button onClick={() => { setSecili(null); setView('ekle'); setHata(null); }}
          className="group flex-shrink-0 flex items-center justify-center gap-3 bg-gradient-to-r from-indigo-600 to-purple-700 hover:from-indigo-700 hover:to-purple-800 text-white px-10 py-4 rounded-2xl text-[10px] font-black shadow-2xl shadow-indigo-200 transition-[background-color,transform] duration-300 hover:-translate-y-1 active:translate-y-0 uppercase tracking-widest relative overflow-hidden">
          <span className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300"></span>
          <span className="relative text-xl transition-transform group-hover:rotate-90">＋</span>
          <span className="relative">YENİ PAKET EKLE</span>
        </button>
      </PageHeader>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {[
          { label: 'TOPLAM PAKET', value: liste.length, icon: '🛌', color: 'from-gray-700 to-gray-900 shadow-gray-200' },
          { label: 'PANSİYONLAR', value: ic('pansiyon'), icon: '🍽️', color: 'from-indigo-500 to-indigo-700 shadow-indigo-100' },
          { label: 'HSD / ULTRA', value: ic('dahil') + ic('hsd'), icon: '👑', color: 'from-purple-500 to-fuchsia-700 shadow-purple-100' },
          { label: 'ÖZEL SERVİS', value: ['balayı', 'spa', 'saatlik', 'aylık', 'haftalık', 'uzun'].reduce((a, k) => a + ic(k), 0), icon: '💎', color: 'from-pink-500 to-rose-700 shadow-pink-100' },
        ].map(k => (
          <div key={k.label} className={`relative overflow-hidden bg-gradient-to-br ${k.color} rounded-[2rem] p-6 text-white shadow-xl hover:shadow-2xl transition-[box-shadow,transform] duration-300 group`}>
            <div className="absolute -right-4 -bottom-4 text-7xl opacity-10 pointer-events-none group-hover:scale-125 transition-transform duration-500">{k.icon}</div>
            <p className="text-[10px] font-black uppercase tracking-widest opacity-70 mb-1 leading-none">{k.label}</p>
            <p className="text-2xl font-black tracking-tight leading-none">{k.value}</p>
          </div>
        ))}
      </div>

      <div className="bg-white rounded-[2.5rem] border border-gray-200 shadow-sm overflow-hidden min-h-[400px]">
        <div className="px-6 md:px-8 py-5 border-b border-gray-100 bg-gray-50/30 flex flex-col md:flex-row items-center gap-6">
          <div className="relative flex-1 w-full">
            <span className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 font-black">🔍</span>
            <input value={arama} onChange={e => setArama(e.target.value)} placeholder="Paket adıyla ara..."
              className="w-full pl-11 pr-4 py-3.5 text-sm border-2 border-gray-100 rounded-2xl focus:border-indigo-400 focus:outline-none bg-white shadow-sm transition-all font-bold" />
          </div>
          <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest ml-auto whitespace-nowrap">Sistemde toplam <b className="text-indigo-600 text-xs">{liste.length}</b> kayıt tanımlı</p>
        </div>

        <div className="p-4 md:p-8">
          {yukleniyor ? (
            <LoadingSpinner fullPage text="Veriler Çekiliyor..." />
          ) : filtrelenmis.length === 0 ? (
            <EmptyState icon="🛌" text="Aradiğiniz kriterde bir konaklama paketi bulunamadı" />
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 leading-none">
              {filtrelenmis.map((item, i) => (
                <div key={item.konaklamaTuruId} className="group relative bg-white border-2 border-gray-50 rounded-[2.5rem] p-7 transition-all duration-500 shadow-sm hover:shadow-2xl hover:border-indigo-100 hover:-translate-y-2 transform-gpu">
                  <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-indigo-50 to-purple-50 rounded-bl-[5rem] group-hover:scale-110 transition-transform duration-500 -mr-6 -mt-6 opacity-40"></div>

                  <div className="flex items-center justify-between mb-8 relative z-10 text-left">
                    <div className="w-16 h-16 rounded-[1.5rem] bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center text-3xl shadow-xl shadow-indigo-100 group-hover:scale-110 group-hover:rotate-6 transition-all duration-500 transform-gpu">
                      {getIkon(item.ad)}
                    </div>
                    <div className="text-right">
                      <span className="text-[10px] font-black text-gray-300 uppercase tracking-widest block mb-3 opacity-60"># {i + 1}</span>
                      {item.ekFiyat > 0 ? (
                        <div className="bg-emerald-50 text-emerald-600 px-3 py-2 rounded-2xl border border-emerald-100 shadow-sm">
                          <span className="text-[8px] font-black uppercase tracking-tighter block leading-none mb-1 opacity-60">EK FİYAT</span>
                          <span className="text-xs font-black tracking-tight leading-none">+{item.ekFiyat.toLocaleString('tr-TR')} ₺</span>
                        </div>
                      ) : (
                        <span className="text-[9px] font-black text-gray-400 uppercase tracking-widest bg-gray-50 border border-gray-100 px-3 py-2 rounded-2xl shadow-inner">STANDART</span>
                      )}
                    </div>
                  </div>

                  <h3 className="font-black text-gray-800 text-lg leading-snug uppercase tracking-tight mb-10 min-h-[3rem] group-hover:text-indigo-600 transition-colors text-left">{item.ad}</h3>

                  <div className="flex gap-2 pt-6 border-t border-gray-50 relative z-10">
                    <EditButton size="lg" onClick={() => { setSecili(item); setView('duzenle'); setHata(null); }} />
                    <DeleteButton size="lg" onClick={() => setSilOnay(item.konaklamaTuruId)} />
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      <UsageInfo
        color="indigo"
        description="Konaklama Paketleri, otelinizde sunulan pansiyon tiplerini ve her tip için geçerli olan ekstra maliyetleri yönetir."
        scenarios={[
          { title: "Otomatik Fiyatlandırma", content: "Burada tanımladığınız 'Ek Fiyat', rezervasyon anında kişi sayısı ve kalınan gece ile çarpılarak toplam oda fiyatına otomatik olarak yansıtılır." },
          { title: "Pansiyon Yönetimi", content: "Oda + Kahvaltı, Yarım Pansiyon gibi standart tiplerin yanı sıra 'Balayı Paketi' veya 'SPA Dahil' gibi özel hizmet içeren paketler oluşturabilirsiniz." },
          { title: "Mutfak Raporları", content: "Hangi misafirin hangi pansiyon türünde konakladığını mutfak birimiyle şeffaf bir şekilde paylaşarak gıda sarfiyat planlamanızı optimize edebilirsiniz." }
        ]}
      />

      {isOpen && createPortal(
        <KonaklamaTuruForm
          kayit={secili}
          onKaydet={kaydet}
          onGeri={() => { setView('liste'); setSecili(null); setHata(null); }}
          kaydediliyor={kaydediliyor}
          hata={hata}
        />,
        document.body
      )}

      {silOnay && createPortal(
        <div className="fixed inset-0 bg-black/60 z-[100] flex items-center justify-center px-4 backdrop-blur-md animate-fade-in shadow-2xl">
          <div className="bg-white rounded-[2.5rem] shadow-2xl p-10 w-full max-w-sm text-center border border-gray-100">
            <div className="w-24 h-24 bg-rose-50 rounded-[2.5rem] flex items-center justify-center mx-auto mb-6 text-5xl shadow-xl shadow-rose-100/50 animate-bounce-subtle">🗑️</div>
            <h3 className="font-black text-gray-900 text-xl tracking-tight uppercase leading-none">Paketi Sil</h3>
            <p className="text-[11px] font-black text-gray-500 mt-5 mb-10 leading-relaxed uppercase tracking-tight text-center">
              <b className="text-gray-900 font-black uppercase">"{liste.find(x => x.konaklamaTuruId === silOnay)?.ad}"</b> paketi kalıcı olarak silinecek. Emin misiniz?
            </p>
            <div className="flex gap-4">
              <button onClick={() => setSilOnay(null)} className="flex-1 py-4 bg-gray-50 text-gray-600 rounded-2xl text-[10px] font-black hover:bg-gray-100 transition-all uppercase tracking-widest active:scale-95">İPTAL</button>
              <button onClick={() => handleSil(silOnay)} className="flex-1 py-4 bg-gradient-to-r from-rose-500 to-red-600 text-white rounded-2xl text-[10px] font-black shadow-xl shadow-rose-200 transition-all uppercase tracking-widest active:scale-95">EVET, SİL</button>
            </div>
          </div>
        </div>,
        document.body
      )}

      <style>{`
        @keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
        .animate-fadeIn { animation: fadeIn 0.4s ease-out forwards; }
        @keyframes scaleIn { from { opacity: 0; transform: scale(0.95); } to { opacity: 1; transform: scale(1); } }
        .animate-scale-in { animation: scaleIn 0.3s ease-out forwards; }
        @keyframes shake { 0%, 100% { transform: translateX(0); } 25% { transform: translateX(-5px); } 75% { transform: translateX(5px); } }
        .animate-shake { animation: shake 0.3s ease-in-out infinite; animation-iteration-count: 2; }
        @keyframes bounceSubtle { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-10px); } }
        .animate-bounce-subtle { animation: bounceSubtle 2s infinite; }
        .no-scrollbar::-webkit-scrollbar { display: none; }
        .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
      `}</style>
    </div>
  );
}